import { getLogo } from "../../common/storage";
import { userGet } from "./userActions";
import Notify from "./notifyActions";
export const CUSTOMER_LIST = "CUSTOMER_LIST";

export const customerList = (pager, customer) => ({
  type: CUSTOMER_LIST,
  payload: {
    request: {
      mode: "no-cors",
      url: "customerlist",
      method: "POST",
      data: pager,
      customer
    }
  }
});

export const CUSTOMER_GET = "CUSTOMER_GET";

export const getCustomer = id => ({
  type: CUSTOMER_GET,
  payload: {
    request: {
      mode: "no-cors",
      url: `customer/${id}`,
      method: "GET"
    }
  }
});

export const CUSTOMER_CREATE = "CUSTOMER_CREATE";
export const CUSTOMER_CREATE_SUCCESSFULL_TOAST =
  "customer_create_successfull_toast";
export const ORG_CREATE_SUCCESSFULL_TOAST = "org_create_successfull_toast";

export const customerCreate = (type, data, pager) => {
  return (dispatch, getState) => {
    return new Promise((resolve, reject) => {
      dispatch({
        type: CUSTOMER_CREATE,
        payload: {
          request: {
            mode: "no-cors",
            url: "customer",
            method: "POST",
            data: { request: data }
          }
        }
      }).then(response => {
        if (response.payload.data.success) {
          if (type && type === "org") {
            dispatch(Notify.success(ORG_CREATE_SUCCESSFULL_TOAST));
          } else {
            dispatch(Notify.success(CUSTOMER_CREATE_SUCCESSFULL_TOAST));
          }
          if (pager) {
            dispatch(customerList(pager));
          }
          resolve();
        } else {
          reject(response.payload.data);
        }
      });
    });
  };
};

export const CUSTOMER_UPLOAD_LOGO = "CUSTOMER_UPLOAD_LOGO";
export const CUSTOMER_UPLOAD_LOGO_SUCCESSFULL_TOAST =
  "customer_upload_logo_successfull_toast";
export const ORG_UPLOAD_LOGO_SUCCESSFULL_TOAST =
  "org_upload_logo_successfull_toast";

export const customerUploadLogo = (type, customerid, data) => {
  return (dispatch, getState) => {
    return new Promise((resolve, reject) => {
      dispatch({
        type: CUSTOMER_UPLOAD_LOGO,
        payload: {
          request: {
            mode: "no-cors",
            url: "logo",
            method: "PUT",
            data: {
              request: {
                customerid: customerid,
                logopath: data.logopath
              }
            }
          }
        }
      }).then(response => {
        if (response.payload.data.success) {
          if (type && type === "org") {
            dispatch(Notify.success(ORG_UPLOAD_LOGO_SUCCESSFULL_TOAST));
          } else {
            dispatch(Notify.success(CUSTOMER_UPLOAD_LOGO_SUCCESSFULL_TOAST));
          }
          resolve();
        } else {
          reject(response.payload.data);
        }
      });
    });
  };
};

export const CUSTOMER_REMOVE_LOGO = "CUSTOMER_REMOVE_LOGO";
export const CUSTOMER_REMOVE_LOGO_SUCCESSFULL_TOAST =
  "customer_remove_logo_successfull_toast";
export const ORG_REMOVE_LOGO_SUCCESSFULL_TOAST =
  "org_remove_logo_successfull_toast";

export const customerRemoveLogo = (type, customerid) => {
  return (dispatch, getState) => {
    return new Promise((resolve, reject) => {
      dispatch({
        type: CUSTOMER_REMOVE_LOGO,
        payload: {
          request: {
            mode: "no-cors",
            url: "logo",
            method: "PUT",
            data: {
              request: {
                customerid: customerid,
                logopath: null
              }
            }
          }
        }
      }).then(response => {
        if (response.payload.data.success) {
          if (type && type === "org") {
            dispatch(Notify.success(ORG_REMOVE_LOGO_SUCCESSFULL_TOAST));
          } else {
            dispatch(Notify.success(CUSTOMER_REMOVE_LOGO_SUCCESSFULL_TOAST));
          }
          resolve();
        } else {
          reject(response.payload.data);
        }
      });
    });
  };
};

export const CUSTOMER_UPDATE = "CUSTOMER_UPDATE";
export const CUSTOMER_UPDATE_SUCCESSFULL_TOAST =
  "customer_update_successfull_toast";
export const ORG_UPDATE_SUCCESSFULL_TOAST = "org_update_successfull_toast";

export const customerUpdate = (type, data, pager) => {
  return (dispatch, getState) => {
    return new Promise((resolve, reject) => {
      dispatch({
        type: CUSTOMER_UPDATE,
        payload: {
          request: {
            mode: "no-cors",
            url: "customer",
            method: "PUT",
            data: {
              request: data
            }
          }
        }
      }).then(response => {

        if (
          response.payload &&
          response.payload.data
        ) {
          if (response.payload.data.success) {
            if (type && type === "org") {
              dispatch(Notify.success(ORG_UPDATE_SUCCESSFULL_TOAST));
            } else {
              dispatch(Notify.success(CUSTOMER_UPDATE_SUCCESSFULL_TOAST));
            }
            dispatch(customerSelect(data.id));
            if (pager) {
              dispatch(customerList(pager));
            }
            let state = getState();
            if (state.userReducer.user && state.userReducer.user.Default && state.userReducer.user.id) {
              dispatch(userGet(state.userReducer.user.id));
            }
            resolve();
          }
          else if (response.payload.data.errors === "error_unauthoriseduser") {
            dispatch(Notify.error("org_update_failed_unauthoriseduser_toast"));
          }
          else if (response.payload.data.errors === "error_nouser") {
            dispatch(Notify.error("org_update_failed_nouser_toast"));
          }
          else {
            reject(response.payload.data);
          }
        }
        else {
          reject(response);
        }
      });
    });
  };
};

export const CUSTOMER_CREATE_RESET = "CUSTOMER_CREATE_RESET";

export const customerCreateReset = () => ({
  type: CUSTOMER_CREATE_RESET
});

export const CUSTOMER_SELECTED = "CUSTOMER_SELECTED";
export const customerSelect = cid => {
  return (dispatch, getState) => {
    dispatch({
      type: CUSTOMER_SELECTED,
      payload: {
        request: {
          mode: "no-cors",
          url: `customer/${cid}`,
          method: "GET"
        }
      }
    }).then(response => {
      const customer = response.payload.data;
      dispatch(customerLoaded(customer));

      //fetch log only if the org has the logo set in the path
      if (customer.logopath) {
        getLogo(customer.id, customer).then(res => {
          customer.logo = res.data;
          dispatch(customerLoaded(customer));
        });
      }
    });
  };
};

export const CUSTOMER_LOADED = "CUSTOMER_LOADED";
export const customerLoaded = customer => ({
  type: CUSTOMER_LOADED,
  data: {
    customer
  }
});

export const CUSTOMER_DELETE = "CUSTOMER_DELETE";
export const CUSTOMER_DELETE_SUCCESSFULL_TOAST =
  "customer_delete_successfull_toast";
export const ORG_DELETE_SUCCESSFULL_TOAST = "org_delete_successfull_toast";
export const CUSTOMER_DELETE_FAIL_TOAST = "customer_delete_fail_toast";
export const ORG_DELETE_FAIL_TOAST = "org_delete_fail_toast";

export const customerDelete = (type, id, pager) => {
  return (dispatch, getState) => {
    return new Promise((resolve, reject) => {
      dispatch({
        type: CUSTOMER_DELETE,
        payload: {
          request: {
            mode: "no-cors",
            url: `customer/${id}`,
            method: "DELETE"
          }
        }
      }).then(response => {
        if (response.type == "CUSTOMER_DELETE_FAIL" && type === "org") {
          dispatch(Notify.error(ORG_DELETE_FAIL_TOAST));
        } else if (response.type == "CUSTOMER_DELETE_FAIL" && type !== "org") {
          dispatch(Notify.error(CUSTOMER_DELETE_FAIL_TOAST));
        } else if (type === "org") {
          dispatch(Notify.success(ORG_DELETE_SUCCESSFULL_TOAST));
        } else {
          dispatch(Notify.success(CUSTOMER_DELETE_SUCCESSFULL_TOAST));
        }
        resolve(true);
        if (pager) {
          dispatch(customerList(pager));
        }
      });
    });
  };
};

export const CUSTOMER_TARGET4_GET = "CUSTOMER_TARGET4_GET";

export const getCustomerTargets4 = id => ({
  type: CUSTOMER_TARGET4_GET,

  payload: {
    request: {
      mode: "no-cors",
      url: `GetTargets`,
      method: "POST",
      data: {
        request: {
          type: "ipv4",
          customerid: id
        }
      }
    }
  }
});

export const CUSTOMER_TARGET6_GET = "CUSTOMER_TARGET6_GET";

export const getCustomerTargets6 = id => ({
  type: CUSTOMER_TARGET6_GET,

  payload: {
    request: {
      mode: "no-cors",
      url: `GetTargets`,
      method: "POST",
      data: {
        request: {
          type: "ipv6",
          customerid: id
        }
      }
    }
  }
});

// export const CUSTOMER_TARGET4_UPDATE = "CUSTOMER_TARGET4_UPDATE";

// export const updateCustomerTargets4 = id => ({
//   type: CUSTOMER_TARGET4_UPDATE,

//   payload: {
//     request: {
//       mode: "no-cors",
//       url: `Targets`,
//       method: "POST",
//       data: {
//         type: "ipv4",
//         customerid: id
//       }
//     }
//   }
// });

// export const CUSTOMER_TARGET6_UPDATE = "CUSTOMER_TARGET6_UPDATE";
// export const updateCustomerTargets66 = id => ({
//   type: CUSTOMER_TARGET6_UPDATE,

//   payload: {
//     request: {
//       mode: "no-cors",
//       url: `Targets`,
//       method: "POST",
//       data: {
//         type: "ipv6",
//         customerid: id
//       }
//     }
//   }
// });

export const TARGETS_UPDATE_SUCCESSFULL_TOAST =
  "targets_update_successfully_toast";

export const CUSTOMER_TARGET4_UPDATE = "CUSTOMER_TARGET4_UPDATE";
export const updateCustomerTargets4 = (id, targetList) => {
  return (dispatch, getState) => {
    return new Promise((resolve, reject) => {
      dispatch({
        type: CUSTOMER_TARGET4_UPDATE,
        payload: {
          request: {
            mode: "no-cors",
            url: `Targets`,
            method: "POST",
            data: {
              request: {
                type: "ipv4",
                customerid: id,
                targets: targetList
              }
            }
          }
        }
      }).then(response => {
        if (
          response.payload &&
          response.payload.data &&
          response.payload.data.success
        ) {
          dispatch(Notify.success(TARGETS_UPDATE_SUCCESSFULL_TOAST));
          dispatch(getCustomerTargets4(id));
        } else {
          reject(response);
        }
      });
    });
  };
};

export const CUSTOMER_TARGET6_UPDATE = "CUSTOMER_TARGET6_UPDATE";
export const updateCustomerTargets6 = (id, targetList) => {
  return (dispatch, getState) => {
    return new Promise((resolve, reject) => {
      dispatch({
        type: CUSTOMER_TARGET6_UPDATE,
        payload: {
          request: {
            mode: "no-cors",
            url: `Targets`,
            method: "POST",
            data: {
              request: {
                type: "ipv6",
                customerid: id,
                targets: targetList
              }
            }
          }
        }
      }).then(response => {
        if (
          response.payload &&
          response.payload.data &&
          response.payload.data.success
        ) {
          dispatch(Notify.success(TARGETS_UPDATE_SUCCESSFULL_TOAST));
          dispatch(getCustomerTargets6(id));
        } else {
          reject(response);
        }
      });
    });
  };
};

export const CUSTOMER_TARGET4_RESET = "CUSTOMER_TARGET4_RESET";
export const CustTargets4Reset = () => ({
  type: CUSTOMER_TARGET4_RESET
});

export const CUSTOMER_TARGET6_RESET = "CUSTOMER_TARGET6_RESET";
export const CustTargets6Reset = () => ({
  type: CUSTOMER_TARGET6_RESET
});

export const CUSTOMER_GET_POELOAD = "CUSTOMER_GET_POELOAD";

export const getCustomerPoELoad = () => ({
  type: CUSTOMER_GET_POELOAD,

  payload: {
    request: {
      mode: "no-cors",
      url: `poeload`,
      method: "GET",
    }
  }
});

export const COUNTRY_STATE_LIST = 'COUNTRY_STATE_LIST'
export const countryStateList = (langCode) => ({
  type: COUNTRY_STATE_LIST,
  payload: {
    request: {
      mode: 'no-cors',
      url: `CountryState/${langCode}`,
      method: 'GET'
    }
  }
})

export const POELOAD_UPDATE_SUCCESSFULL_TOAST = "poeload_update_successfully_toast";
export const CUSTOMER_UPDATE_POELOAD = "CUSTOMER_UPDATE_POELOAD";
export const updateCustomerPoELoad = (poeload) => {
  return (dispatch, getState) => {
    return new Promise((resolve, reject) => {
      dispatch({
        type: CUSTOMER_TARGET6_UPDATE,
        payload: {
          request: {
            mode: "no-cors",
            url: `poeload`,
            method: "POST",
            data: {
              request: {
                ...poeload
              }
            }
          }
        }
      }).then(response => {
        if (
          response.payload &&
          response.payload.data &&
          response.payload.data.success
        ) {
          dispatch(Notify.success(POELOAD_UPDATE_SUCCESSFULL_TOAST));
          dispatch(getCustomerPoELoad());
        } else {
          reject(response);
        }
      });
    });
  };
};; 



// WEBPACK FOOTER //
// ./src/redux/actions/customerActions.js